import React from 'react';
import axios from 'axios';
import { Button } from '@mui/material';


const API_URL = process.env.REACT_APP_API_URL;


const ExportUsersButton = () => {
  const handleDownload = () => {
    axios({
      url: `${API_URL}/api/export_users/`,  // The backend URL
      method: 'GET',
      responseType: 'blob',  // Set response type to blob to handle the Excel file
    })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'users.xlsx');  // Specify the filename for the download
      document.body.appendChild(link);
      link.click();
    })
    .catch((error) => {
      console.error("There was an error downloading the file!", error);
    });
  };

  return (
    <Button variant="contained" onClick={handleDownload}>
      Download Excel
    </Button>
  );
};

export default ExportUsersButton;
